import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/icon_menu.svg'
import _imports_1 from '../assets/icons/icon_enter.svg'


const _hoisted_1 = { class: "sm:hidden px-50px horiz-center mt-20px justify-between" }
const _hoisted_2 = { class: "hover:opacity-60" }
const _hoisted_3 = {
  class: "fill-black h-20px w-20px",
  src: _imports_0
}
const _hoisted_4 = { href: "https://rko-group.ru/auth/" }
const _hoisted_5 = { class: "hover:opacity-60" }
const _hoisted_6 = {
  class: "fill-black h-20px w-20px",
  src: _imports_1
}
const _hoisted_7 = { class: "horiz-center max-w-1440px <sm:hidden mx-auto pl-203px <lg:pl-65px <xl:pl-105px pr-175px <lg:pr-40px <xl:pr-85px mt-50px" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "text-22px abs-horiz-center whitespace-nowrap -bottom-54px <xl:-bottom-40px <sm:-bottom-11px pl-10px <xl:pl-7px" }
const _hoisted_10 = { href: "https://rko-group.ru/auth/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_logo = _resolveComponent("logo")!
  const _component_the_header_button = _resolveComponent("the-header-button")!
  const _component_login_button = _resolveComponent("login-button")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/menu" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_2, [
            _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
              [_directive_svg_inline]
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_logo),
      _createElementVNode("a", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
            [_directive_svg_inline]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_logo),
      _createVNode(_component_the_header_button, {
        class: "ml-65px",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToAnchor('about')))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("О нас")
        ])),
        _: 1
      }),
      _createVNode(_component_the_header_button, {
        class: "ml-38px <lg:ml-23px",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToAnchor('how')))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Как работаем")
        ])),
        _: 1
      }),
      _createVNode(_component_the_header_button, {
        class: "ml-36px <lg:ml-21px",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToAnchor('advantages')))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Преимущества")
        ])),
        _: 1
      }),
      _createVNode(_component_the_header_button, {
        class: "ml-38px <lg:ml-23px <700:hidden",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToAnchor('feedback')))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("Отзывы")
        ])),
        _: 1
      }),
      _createVNode(_component_the_header_button, {
        class: "ml-37px <lg:ml-22px <750:hidden",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToAnchor('contacts')))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("Контакты")
        ])),
        _: 1
      }),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "spacer" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("a", {
          href: "tel:+79254182128",
          class: "text-22px <xl:text-17px <lg:text-14px block transform translate-y-1px <sm:hidden"
        }, "+7 925 418 21 28", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createVNode(_component_login_button)
          ])
        ])
      ])
    ])
  ], 64))
}